// NZ Specific employment Status
export const RENTAL_INCOME = 'RENTAL_INCOME';
export const INVESTMENT = 'INVESTMENT';
export const SELF_EMPLOYED = 'SELF_EMPLOYED';
export const CONTRACTOR_SELF_EMPLOYED = 'CONTRACTOR_SELF_EMPLOYED';
export const PERMANENT = 'PERMANENT';
export const CASUAL_SEASONAL_TEMPORARY = 'CASUAL_SEASONAL_TEMPORARY';
export const CONTRACTOR_FIXED_TERM = 'CONTRACTOR_FIXED_TERM';
export const SUPERANNUATION = 'SUPERANNUATION';
export const GOVERNMENT_BENEFIT = 'GOVERNMENT_BENEFIT';
export const ACC = 'ACC';

// Australia specific employment Status
export const CASUAL_TEMPORARY = 'CASUAL_TEMPORARY';
export const PERMANENT_PART_TIME = 'PERMANENT_PART_TIME';
export const PERMANENT_FULL_TIME = 'PERMANENT_FULL_TIME';
export const SELF_EMPLOYED_SUBCONTRACTOR = 'SELF_EMPLOYED_SUBCONTRACTOR';
export const CONTRACTOR_PART_TIME = 'CONTRACTOR_PART_TIME';
export const CONTRACTOR_FULL_TIME = 'CONTRACTOR_FULL_TIME';
export const WORKERS_COMPENSATION = 'WORKERS_COMPENSATION';
export const GOVERNMENT_BENEFITS = 'GOVERNMENT_BENEFITS';
export const UNEMPLOYED = 'UNEMPLOYED';
export const OTHER = 'OTHER';
export const SELF_FUNDED_RETIREES = 'SELF_FUNDED_RETIREES';
export const RETIRED = 'RETIRED';
export const CHILD_SUPPORT = 'CHILD_SUPPORT';
export const STUDENT = 'STUDENT';
export const HOME_DUTIES = 'HOME_DUTIES';
export const PENSIONER = 'PENSIONER';

// Australia specific income employment Status
export const PERMANENT_FULL_PART_TIME_FIXED_TERM = 'PERMANENT_FULL_PART_TIME_FIXED_TERM';

// Additional income type values introduced for the secondary income dropdown
export const GIG_WORK = 'GIG_WORK';
export const SHARES_DIVIDENDS = 'SHARES_DIVIDENDS';
export const INTEREST_INCOME = 'INTEREST_INCOME';
export const employmentStatusOptionsNZ = [
  {
    value: PERMANENT,
    label: 'Permanent full or part time',
  },
  {
    value: PERMANENT_FULL_TIME,
    label: 'Permanent Full Time',
  },
  {
    value: PERMANENT_PART_TIME,
    label: 'Permanent Part Time',
  },
  {
    value: CASUAL_SEASONAL_TEMPORARY,
    label: 'Casual/Seasonal/Temporary',
  },
  {
    value: CONTRACTOR_FIXED_TERM,
    label: 'Contractor - fixed term',
  },
  {
    value: CONTRACTOR_SELF_EMPLOYED,
    label: 'Contractor - self employed',
  },
  {
    value: SELF_EMPLOYED,
    label: 'Self employed',
  },
  {
    value: SUPERANNUATION,
    label: 'Superannuation',
  },
  {
    value: GOVERNMENT_BENEFIT,
    label: 'Government Benefit',
  },
  {
    value: ACC,
    label: 'ACC',
  },
  {
    value: RENTAL_INCOME,
    label: 'Rental income',
  },
  {
    value: INVESTMENT,
    label: 'Investment',
  },
];

export const employmentStatusOptionsNzV2 = [
  {
    value: PERMANENT_FULL_TIME,
    label: 'Permanent Full Time',
  },
  {
    value: PERMANENT_PART_TIME,
    label: 'Permanent Part Time',
  },
  {
    value: CASUAL_SEASONAL_TEMPORARY,
    label: 'Casual/Seasonal/Temporary',
  },
  {
    value: CONTRACTOR_FIXED_TERM,
    label: 'Contractor Fixed Term',
  },
  {
    value: CONTRACTOR_SELF_EMPLOYED,
    label: 'Contractor Self-Employed',
  },
  {
    value: SELF_EMPLOYED,
    label: 'Self-Employed',
  },
  {
    value: UNEMPLOYED,
    label: 'I am not employed (e.g. Rental Income, Investment etc)',
  },
];

export const employmentStatusOptionsAU = [
  {
    value: CASUAL_TEMPORARY,
    label: 'Casual/Temporary',
  },
  {
    value: PERMANENT_PART_TIME,
    label: 'Permanent Part Time',
  },
  {
    value: PERMANENT_FULL_TIME,
    label: 'Permanent Full Time',
  },
  {
    value: CONTRACTOR_PART_TIME,
    label: 'Contractor Part Time',
  },
  {
    value: CONTRACTOR_FULL_TIME,
    label: 'Contractor Full Time',
  },
  {
    value: SELF_EMPLOYED_SUBCONTRACTOR,
    label: 'Self-Employed/Subcontractor',
  },
  {
    value: UNEMPLOYED,
    label: "I'm not employed (e.g. Self-Funded Retiree, Student, Home Duties)",
  },
];

// for post submission
export const applicationEmpStatusOptionsAU = [
  {
    value: CASUAL_TEMPORARY,
    label: 'Casual/Temporary',
  },
  {
    value: PERMANENT_PART_TIME,
    label: 'Permanent Part Time',
  },
  {
    value: PERMANENT_FULL_TIME,
    label: 'Permanent Full Time',
  },
  {
    value: SELF_EMPLOYED_SUBCONTRACTOR,
    label: 'Self-Employed/Subcontractor',
  },
  {
    value: CONTRACTOR_PART_TIME,
    label: 'Contractor Part Time',
  },
  {
    value: CONTRACTOR_FULL_TIME,
    label: 'Contractor Full Time',
  },
  {
    value: WORKERS_COMPENSATION,
    label: "Worker's Compensation",
  },
  {
    value: GOVERNMENT_BENEFITS,
    label: 'Government Benefits',
  },
  {
    value: UNEMPLOYED,
    label: 'Unemployed',
  },
  {
    value: RETIRED,
    label: 'Self-funded retiree',
  },
  {
    value: OTHER,
    label: 'Other',
  },
];

// Additional income type dropdown — rendered as <optgroup> via GroupedSelect.
// AU and NZ differ only on the workers-compensation slot: AU = Workers Compensation, NZ = ACC.
const buildAdditionalIncomeTypeGroups = compensationOption => [
  {
    label: 'Most Common',
    options: [
      { value: RENTAL_INCOME, label: 'Rental Income' },
      { value: GOVERNMENT_BENEFITS, label: 'Government Benefits' },
      { value: GIG_WORK, label: 'Gig work (Uber, DiDi etc)' },
      { value: CHILD_SUPPORT, label: 'Child Support Payments' },
    ],
  },
  {
    label: 'Employment - second job',
    options: [
      { value: CASUAL_TEMPORARY, label: 'Casual/ Temporary' },
      { value: PERMANENT_PART_TIME, label: 'Permanent Part Time' },
      { value: SELF_EMPLOYED_SUBCONTRACTOR, label: 'Self Employment/ Sub Contractor' },
      { value: CONTRACTOR_PART_TIME, label: 'Contractor Part Time' },
      { value: CONTRACTOR_FULL_TIME, label: 'Contractor Full Time' },
    ],
  },
  {
    label: 'Investment & Other',
    options: [
      { value: SHARES_DIVIDENDS, label: 'Shares/ Dividends' },
      { value: SUPERANNUATION, label: 'Superannuation/ Pension' },
      { value: INTEREST_INCOME, label: 'Interest Income' },
      compensationOption,
      { value: SELF_FUNDED_RETIREES, label: 'Self Funded Retiree' },
    ],
  },
];

export const additionalIncomeTypeGroupsAU = buildAdditionalIncomeTypeGroups({
  value: WORKERS_COMPENSATION,
  label: 'Workers Compensation',
});

export const additionalIncomeTypeGroupsNZ = buildAdditionalIncomeTypeGroups({
  value: ACC,
  label: 'ACC',
});

export const unemploymentStatusOptionsAU = [
  { label: "I'm not working currently", value: UNEMPLOYED },
  { label: "I receive worker's compensation", value: WORKERS_COMPENSATION },
  { label: 'I receive government benefits', value: GOVERNMENT_BENEFITS },
  { label: "I'm a student", value: STUDENT },
  { label: 'I receive a pension', value: PENSIONER },
  { label: "I'm a self-funded retiree", value: RETIRED },
  { label: 'I receive child support payments', value: CHILD_SUPPORT },
  { label: 'I manage home duties', value: HOME_DUTIES },
  { label: 'Other', value: OTHER },
];

export const unemploymentStatusOptionsNz = [
  { label: 'I receive Superannuation', value: SUPERANNUATION },
  { label: 'I receive ACC payments', value: ACC },
  { label: 'I earn rental income', value: RENTAL_INCOME },
  { label: 'I have investment earnings', value: INVESTMENT },
  { label: 'I receive Government benefits', value: GOVERNMENT_BENEFIT },
];

export const employmentStatusLabelsByValueNZ = employmentStatusOptionsNZ.reduce((output, option) => {
  return {
    ...output,
    [option.value]: option.label,
  };
}, {});

export const incomeEmploymentStatusOptionsAU = [
  {
    value: PERMANENT_FULL_PART_TIME_FIXED_TERM,
    label: 'Permanent Full/Part Time & Fixed Term Contract',
  },
  {
    value: CASUAL_SEASONAL_TEMPORARY,
    label: 'Casual/Seasonal/Temporary',
  },
  {
    value: GOVERNMENT_BENEFITS,
    label: 'Government Benefits',
  },
  {
    value: SELF_EMPLOYED_SUBCONTRACTOR,
    label: 'Self-Employed/Subcontractor',
  },
  {
    value: RENTAL_INCOME,
    label: 'Rental income',
  },
  {
    value: SELF_FUNDED_RETIREES,
    label: 'Self-Funded Retirees',
  },
  {
    value: WORKERS_COMPENSATION,
    label: 'Workers Compensation',
  },
  {
    value: CHILD_SUPPORT,
    label: 'Child Support',
  },
];

export const isRentalOrInvestment = employmentStatus => {
  return employmentStatus === RENTAL_INCOME || employmentStatus === INVESTMENT;
};

export const isSelfEmployedByStatus = employmentStatus => {
  return [SELF_EMPLOYED, CONTRACTOR_SELF_EMPLOYED].includes(employmentStatus);
};

export const isSuperOrGov = employmentStatus => {
  return [SUPERANNUATION, GOVERNMENT_BENEFIT].includes(employmentStatus);
};

export const isGovernmentBenefit = incomeSource => {
  return [HOME_DUTIES, PENSIONER, RETIRED, STUDENT, GOVERNMENT_BENEFITS].includes(incomeSource);
};

export const isEligibleForBankConnectAndBankStatementNz = employmentStatus => {
  return [
    PERMANENT,
    PERMANENT_FULL_TIME,
    PERMANENT_PART_TIME,
    CASUAL_SEASONAL_TEMPORARY,
    CONTRACTOR_FIXED_TERM,
    SUPERANNUATION,
    ACC,
  ].includes(employmentStatus);
};

export const isEligibleForBankConnectAndBankStatementAu = employmentDetails => {
  const { employmentStatus, industry } = employmentDetails;

  if (employmentStatus === GOVERNMENT_BENEFITS && industry === HOME_DUTIES) return false;

  return [
    CASUAL_TEMPORARY,
    PERMANENT_PART_TIME,
    PERMANENT_FULL_TIME,
    CONTRACTOR_PART_TIME,
    CONTRACTOR_FULL_TIME,
    GOVERNMENT_BENEFITS,
    WORKERS_COMPENSATION,
    RETIRED,
    OTHER,
  ].includes(employmentStatus);
};

export const unemployedLengthLabels = {
  [UNEMPLOYED]: 'How long have you not been working?',
  [WORKERS_COMPENSATION]: 'How long have you been receiving workers compensation?',
  [GOVERNMENT_BENEFITS]: 'How long have you been receiving government benefits?',
  [STUDENT]: 'How long have you been a student?',
  [PENSIONER]: 'How long have you been receiving a pension?',
  [RETIRED]: 'How long have you been a self-funded retiree?',
  [CHILD_SUPPORT]: 'How long have you been receiving child support payments?',
  [HOME_DUTIES]: 'How long have you been managing home duties?',
  [OTHER]: 'How long have you been in this situation?',
};

export const employmentStatusLabels = {
  [RETIRED]: 'Self-funded retiree',
  [RENTAL_INCOME]: 'Rental income',
  [CHILD_SUPPORT]: 'Child Support',
  [GOVERNMENT_BENEFITS]: 'Government Benefits',
  [WORKERS_COMPENSATION]: "Worker's Compensation",
};
